import type { Chart } from "../models/chart";
import type { Report } from "../models/report";

const reports: Report[] = [];

function addReport(report: Report): void {
  reports.push(report);
}

export interface ReportRunResult {
  title: string;
  data: ReturnType<Report["getData"]>;
  output: string;
}

function runReport(report: Report, chart: Chart): ReportRunResult {
  const reportData = report.run(chart);
  return {
    title: report.title,
    data: report.getData(),
    output: reportData,
  };
}

function logAllReports(chart: Chart): string {
  const allReportsData: ReportRunResult[] = [];

  reports.forEach((report) => {
    const reportResult = runReport(report, chart);
    allReportsData.push(reportResult);
    console.log(`${report.title}:`, report.getData());
  });

  return JSON.stringify(allReportsData, null, 2);
}

export const ReportController = {
  addReport,
  logAllReports,
};
